import { Schedule } from 'types'
import { ScheduleTable } from '../ScheduleTable/ScheduleTable'

export function ScheduleItem({ schedule }: { schedule: Schedule }) {
  return <ScheduleTable schedule={schedule} />
}
